<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Security') }}</h4>
        </div>
      </div>
    </div>

    <div class="vflex-row-1 p-3">
      <div class="shurt-conatiner">
        <h5>{{ $t('Change password') }}</h5>
        <p>{{ $t('Keep your account safe and secure by regularly changing passwords.') }}</p>
        <router-link
          class="btn btn-primary"
          to="/config/password">
          {{ $t('Change password') }}
          </router-link>
        <hr>
        <h5>{{ $t('Two-step verification') }}</h5>
        <p>{{ $t('Protect your account with an extra layer of security. A second login step can keep your account secure even if someone discovers your password. To activate 2-Step Verification, all you need is a smartphone.') }}</p>
        <div v-if="!twofaEnable">
          <router-link
            class="btn btn-outline-primary"
            to="/config/2fa/enable">
            {{ $t('Enable 2-step verification') }}
            </router-link>
        </div>
        <div v-if="twofaEnable">
          <p>{{ $t('Status:') }} <b class="text-success">{{ $t('Enabled') }}</b></p>
          <router-link
            class="btn btn-outline-danger"
            to="/config/2fa/disable">
            {{ $t('Disable') }}
            </router-link>
        </div>
        <hr>
        <h5>{{ $t('Manage connected devices') }}</h5>
        <p>{{ $t('View and manage all devices currently connected to your account. Revoke access from unauthorized devices and maintain full control of access.') }}</p>
        <router-link
          class="btn btn-primary"
          to="/config/sessions">
          {{ $t('Connected devices') }}
          </router-link>
        <div v-if="permissions.includes('manage_settings')">
          <hr>
          <h5>{{ $t('Single Sign-On (SSO)') }}</h5>
          <p>{{ $t('Configure o Single Sign-On (SSO) para permitir que os usuários da sua conta façam login usando o provedor de identidade de sua escolha.') }}</p>
          <router-link
            class="btn btn-primary"
            to="/config/sso">
            {{ $t('Setup') }}
            </router-link>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: 'ProfileSecurity',
  components: {
  },
  data () {
    return {
    }
  },
  created () {
  },
  computed: {
    me () {
      return this.$store.getters.getMe
    },
    twofaEnable () {
      return this.me.twofa_enable
    },
    permissions () {
      return this.$store.getters.getPermissions
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Profile/ProfileSecurity.vue